export default "__VITE_ASSET__b88365d2__"